import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer,
  throwSubtypeNotRegistered343gt7v9eqwun as throwSubtypeNotRegistered,
  throwSubtypeNotRegistered2cr459177l268 as throwSubtypeNotRegistered_0,
} from './internal/AbstractPolymorphicSerializer.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import {
  OPEN_getInstance3fojhnrvzj4l0 as OPEN_getInstance,
  CONTEXTUAL_getInstance20l1ap7hne5we as CONTEXTUAL_getInstance,
} from './descriptors/SerialKinds.mjs';
import { StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { serializer1x79l67jvwntn as serializer } from './builtins/BuiltinSerializers.mjs';
import { buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor } from './descriptors/SerialDescriptors.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { withContext3ge61vpog00ae as withContext } from './descriptors/ContextAware.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function PolymorphicSerializer$_get_descriptor_$ref_8tw9if() {
  return constructCallableReference((p0) => p0.b1n(), 1, 0, 7);
}
var PolymorphicSerializerClass;
function PolymorphicSerializer() {
  if (PolymorphicSerializerClass === VOID) {
    class $ extends AbstractPolymorphicSerializer() {
      constructor(baseClass) {
        return new.target.h1n(baseClass);
      }
      static h1n(baseClass) {
        var $this = this.i1n();
        $this.e1n_1 = baseClass;
        $this.f1n_1 = emptyList();
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.g1n_1 = lazy(tmp_0, () => {
          var tmp = OPEN_getInstance();
          return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], ($this$buildSerialDescriptor) => {
            $this$buildSerialDescriptor.r1n('type', serializer(StringCompanionObject_instance).b1n());
            $this$buildSerialDescriptor.r1n('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + $this.e1n_1.j1() + '>', CONTEXTUAL_getInstance(), []));
            $this$buildSerialDescriptor.l1n_1 = $this.f1n_1;
            return Unit_instance;
          }), $this.e1n_1);
        });
        return $this;
      }
      s1n() {
        return this.e1n_1;
      }
      b1n() {
        var tmp0 = this.g1n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, PolymorphicSerializer$_get_descriptor_$ref_8tw9if(), null);
        return tmp0.n3();
      }
      toString() {
        return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString(this.e1n_1) + ')';
      }
    }
    initMetadataForClass($, 'PolymorphicSerializer');
    PolymorphicSerializerClass = $;
  }
  return PolymorphicSerializerClass;
}
function findPolymorphicSerializer(_this__u8e3s4, encoder, value) {
  var tmp0_elvis_lhs = _this__u8e3s4.v1n(encoder, value);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered(getKClassFromExpression(value), _this__u8e3s4.s1n());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function findPolymorphicSerializer_0(_this__u8e3s4, decoder, klassName) {
  var tmp0_elvis_lhs = _this__u8e3s4.u1n(decoder, klassName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered_0(klassName, _this__u8e3s4.s1n());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
//region block: exports
export {
  PolymorphicSerializer as PolymorphicSerializer3p3fzpdobi8hh,
  findPolymorphicSerializer_0 as findPolymorphicSerializer1nm87hvemahcj,
  findPolymorphicSerializer as findPolymorphicSerializerk638ixyjovk5,
};
//endregion

//# sourceMappingURL=PolymorphicSerializer.mjs.map
